export type PasswordCriterionId =
  | 'length'
  | 'uppercase'
  | 'lowercase'
  | 'number'
  | 'special';

export interface PasswordCriterion {
  id: PasswordCriterionId;
  label: string;
  met: boolean;
}

const RULES: Array<{ id: PasswordCriterionId; label: string; test: (password: string) => boolean }> = [
  { id: 'length', label: 'At least 8 characters', test: (password) => password.length >= 8 },
  { id: 'uppercase', label: 'One uppercase letter', test: (password) => /[A-Z]/.test(password) },
  { id: 'lowercase', label: 'One lowercase letter', test: (password) => /[a-z]/.test(password) },
  { id: 'number', label: 'One number', test: (password) => /\d/.test(password) },
  { id: 'special', label: 'One special character', test: (password) => /[^A-Za-z0-9]/.test(password) },
];

export function evaluatePasswordCriteria(password: string): PasswordCriterion[] {
  const value = password || '';
  return RULES.map((rule) => ({
    id: rule.id,
    label: rule.label,
    met: rule.test(value),
  }));
}

export function isPasswordValid(password: string): boolean {
  return evaluatePasswordCriteria(password).every((rule) => rule.met);
}
